import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer } from 'recharts';
import Tooltip from "react-simple-tooltip"
import EmailToTarget from './ActionStats/EmailToTarget'
import Survey from './ActionStats/Survey'
import Donate from './ActionStats/Donate'
import Share from './ActionStats/Share'
import useActionLabel from '../useActionLabel'
import './PageContainer.scoped.scss'

function StepLabel({ step, index, onClick }) {
  const formattedName = useActionLabel(step.name)

  if (step.active === false) {
    return (
      <Tooltip
        content="This step has been removed."
        radius={6}
        padding={8}
        background="#333"
        fontSize="12px"
        customCss={{
          whiteSpace: 'nowrap',
          maxWidth: '200px'
        }}
      >
        <p
          key={index}
          onClick={onClick}
          style={{
            cursor: 'pointer',
            textDecoration: 'line-through'
          }}
        >
          {formattedName}
        </p>
      </Tooltip>
    )
  }

  return (
    <p
      key={index}
      onClick={onClick}
      style={{
        cursor: 'pointer',
        textDecoration: 'none'
      }}
    >
      {formattedName}
    </p>
  )
}

function FlowSteps({ }) {
  const { id, stats, actions } = useSel((s) => s.flow)

  const stepsData = (stats?.steps || []).map((step) => {
    return {
      name: step.kind,
      amountLeft: step.total - step.completed,
      completed: step.completed,
      total: step.total,
      active: step.active
    }
  })

  // Helper function to find first active action of a given kind, falling back to any action of that kind
  const findActiveAction = (kind) => {
    if (!actions) return undefined
    const activeAction = actions.find((action) => action.kind === kind && action.active !== false)
    return activeAction || actions.find((action) => action.kind === kind)
  }

  const emailToTargetAction = useMemo(() => findActiveAction('email_to_target'), [actions])
  const surveyAction = useMemo(() => findActiveAction('survey'), [actions])
  const donateAction = useMemo(() => findActiveAction('donate'), [actions])
  const shareAction = useMemo(() => findActiveAction('share'), [actions])

  const scrollToSection = (stepKind) => {
    const element = document.getElementById(stepKind)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return <>
    <div className='box flex column margin-top double' id='analytics'>
      <h2 className='no-margin-top'>Page Steps</h2>
      <div className="step-container">
        <div className="info">
          <div className="example-box">
            <span className="color-swatch" style={{ background: '#00F399' }}></span>
            <p>Completed</p>
          </div>
          <div className="example-box">
            <span className="color-swatch" style={{ background: 'rgba(24, 24, 91, 0.2)' }}></span>
            <p>Started</p>
          </div>
        </div>
        <div className="data">
          <div className="chart-keys">
            {stepsData.map((step, index) => (
              <StepLabel
                step={step}
                index={index}
                onClick={() => scrollToSection(step.name)}
              />
            ))}
          </div>
          <ResponsiveContainer width="100%" height={stepsData.length * 42}>
            <BarChart
              layout="vertical"
              data={stepsData}
              barSize={20}
            >
              <YAxis dataKey="name" type="category" width={100} hide={true} />
              <XAxis type="number" hide={true} />
              <Bar dataKey="completed" stackId="a" fill="#00F399" />
              <Bar dataKey="amountLeft" stackId="a" fill="rgba(24, 24, 91, 0.1)" />
            </BarChart>
          </ResponsiveContainer>
          <div className="text-data">
            {stepsData.map((step, index) => (
              <p key={index}>{step.completed}/{step.total}</p>
            ))}
          </div>
        </div>
      </div>
    </div>
    {emailToTargetAction &&
      <EmailToTarget flowId={id} actionId={emailToTargetAction.id} removed={!emailToTargetAction.active} />
    }
    {surveyAction &&
      <Survey flowId={id} actionId={surveyAction.id} removed={!surveyAction.active} />
    }
    {donateAction &&
      <Donate flowId={id} actionId={donateAction.id} removed={!donateAction.active} />
    }
    {shareAction &&
      <Share flowId={id} actionId={shareAction.id} removed={!shareAction.active} />
    }
  </>
}

export default FlowSteps